module.exports = __webpack_public_path__ + "login/img/teste1.0eacd74.png";


//////////////////
// WEBPACK FOOTER
// ./assets/teste1.png
// module id = hI1U
// module chunks = 2